import l10n from "../localization";
import { normalizeWords } from "../formatters";

const validateFullName = (name) =>
  normalizeWords(name).split(" ").length < 2 && l10n.getString("fields.fullName.validation");

export default validateFullName;
